export const I18N_CONFIG = {
  defaultLanguage: 'zh-TW', // 默认使用繁体中文
  supportedLanguages: ['en', 'zh-CN', 'zh-TW'] as const,
  namespaces: ['common'] as const,
  localStorageKey: 'app-language', // 统一使用一个键
} as const

export type SupportedLanguage = typeof I18N_CONFIG.supportedLanguages[number]
export type Namespace = typeof I18N_CONFIG.namespaces[number]